module.exports = {"title":"Get answers to your Qs","image":"/media/faq_cover.jpg","overlap":true}